"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
const testimonials = [{
  id: 1,
  quote: "\"La metodología de CENTRO COSMOS me permitió avanzar a mi propio ritmo con una claridad que no encontré en otras academias.\"",
  author: "Martina R.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/estudiante_martina.png",
  retreatType: "Alumno Verificado"
}, {
  id: 2,
  quote: "El diseño de los cursos es impecable. Todo es visual, directo y extremadamente fácil de seguir para principiantes.",
  author: "Julián S.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/estudiante_julian.png",
  retreatType: "Alumno Verificado"
}, {
  id: 3,
  quote: "Gracias a CENTRO COSMOS pude certificarme en tiempo récord. La plataforma es intuitiva y el contenido es de altísima calidad.",
  author: "Lucía P.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/estudiante_lucia.png",
  retreatType: "Alumno Verificado"
}];
export default function VoicesOfRejuvenation() {
  return <section data-section-id="242303" id="lo-que-dicen-nuestros-alumnos" className="bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-primary/5 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full max-w-4xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                <div className="flex flex-col items-center text-center px-4 md:px-16 py-8">
                  <Quote className="size-10 text-primary/10 mb-8" aria-hidden="true" />
                  
                  <p className="font-default italic text-lg md:text-[18px] leading-relaxed md:leading-tight mb-12 text-foreground/90">
                    "{testimonial.quote}"
                  </p>
                  
                  
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="hidden md:block">
            <CarouselPrevious className="left-0 lg:-left-12 bg-background/80 border-border hover:bg-accent hover:text-accent-foreground backdrop-blur-sm" />
            <CarouselNext className="right-0 lg:-right-12 bg-background/80 border-border hover:bg-accent hover:text-accent-foreground backdrop-blur-sm" />
          </div>
        </Carousel>
      </div>
    </section>;
}